import styled from 'styled-components';
import {
  Collapse,
  Form,
  Tabs,
  Checkbox,
  Tree,
  Descriptions,
  Modal,
  Drawer
} from 'antd';
const CheckboxGroup = Checkbox.Group;

export const StyledFormType = styled.div`
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.title.color};
  font-weight: ${(props) => props.theme.title.fontWeight};
`;

export const CardTitle = styled.div`
  padding: 0px 0px 6px;
  
  font-weight: bolder;
  color: ${(props) => props.theme.list.card.titleColor};
`;

export const CardFooterActions = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px;
  
`;


export const StyledForm = styled(Form)`
  .ant-divider-horizontal.ant-divider-with-text {
    display: flex;
    margin: 16px 0;
    font-weight: 500;
    
    white-space: nowrap;
    text-align: center;
    border-top: 0;
  }

  .ant-form-item-label > label {
    color: ${(props) => props.theme.form.formLabel} !important;
    font-weight: revert;
    font-weight: bold;
  }

  .ant-tabs-content-holder {
    border-radius: 0 5px 5px 5px;
  }
`;

export const StyledSubForm = styled.div`
  background: ${(props) => props.theme.form.subSectionBackgroundColor};
  padding: 20px;
  min-height: 300px;
`;


export const StyledTabs = styled(Tabs)`
  .ant-tabs-tab {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 12px 0;
    
    background: transparent;
    border: 0;
    outline: none;
    cursor: pointer;
  }

  .ant-tabs-tab-remove {
    flex: none;
    margin-right: -4px;
    margin-left: 8px;
    
    background: #1a3b5c;
    border: none;
    outline: none;
    cursor: pointer;
    transition: all 0.3s;
    color: white !important;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(props) => props.theme.form.tabs.color};
    text-shadow: 0 0 0.25px currentcolor;
  }
`;

export const StyledCollapse = styled(Collapse)`
   {
    background-color: ${(props) => props.theme.form.collapse.backgroundColor} !important;
    color: white !important;

    .ant-collapse-content-box {
      background-color: ${(props) => props.theme.form.collapse.backgroundColor} !important;
    }
    .ant-collapse-item > .ant-collapse-header {
      color: #fff !important;
    }
    .ant-collapse > .ant-collapse-item > .ant-collapse-header {
      position: relative;
      display: flex;
      flex-wrap: nowrap;
      align-items: flex-start;
      padding: 12px 16px;
      color: #fff;
      line-height: 1.5715;
      cursor: pointer;
      transition: all 0.3s, visibility 0s;
    }
  }
`;

export const StyledNoBorderSelect = styled.div`
  padding: 5px;
  .ant-list {
    color: rgba(224, 203, 203, 0.85);
    
    font-variant: tabular-nums;
    line-height: 1.5715;
    list-style: none;
    font-feature-settings: 'tnum', 'tnum';
  }

  .ant-list-item-meta-title > a {
    color: #fff !important;
    
  }

  .ant-list-item {
    color: #fff !important;
  }

  .ant-list-split .ant-list-item {
    border-bottom: 10px solid #1a3652;
    background: #1a4c7e !important;
    overflow: auto;
    max-height: 150px !important;
  }

  .ant-list-item-meta-description {
    color: rgba(236, 232, 232, 0.45) !important;
  }

`;

export const StyledSubHeading = styled.div`
  display: flex;
  justify-content: center;
  font-weight: bold;
  padding: 20px;
`;

export const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox .ant-checkbox-inner {
    border-color: rgb(217, 142, 4);
    background-color: transparent;
  }

  .ant-checkbox-disabled .ant-checkbox-inner {
    border-color: rgb(217, 142, 4);
    background-color: rgb(217, 142, 4);
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: rgb(217, 142, 4);
    border-color: rgb(217, 142, 4);
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #d98e04 !important;
    border-color: #d98e04 !important;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #f55e00 !important;
  }
  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: rgb(217, 142, 4) !important;
  }
  .ant-checkbox-disabled + span {
    color: #d98e04 !important;
    cursor: not-allowed;
  }
`;

export const StyledTabsContent = styled.div`
  margin-top: 20px;
  color: black;
  fontweight: bold;
`;

export const StyledTree = styled(Tree)`
  background: #1a3652 !important;
  color: white !important;
`;

export const StyledDescriptions = styled(Descriptions)`
  .ant-descriptions-item-label {
    color: #d98e04;
    font-weight: bold;
    
    line-height: 1.5715;
    text-align: start;
  }

  .ant-descriptions-item-content {
    display: table-cell;
    flex: 1 1;
    color: white;
    
    line-height: 1.5715;
    word-break: break-word;
    overflow-wrap: break-word;
  }
`;

export const StyleModal = styled(Modal)`
  width: 85% !important;

  .ant-modal-content {
    border-radius: 20px;
    background: #1a3652;
  }

  .ant-modal-header {
    background: #1a3652;
  }
  .ant-modal-title {
    color: #ffffff !important;
  }
  .ant-form-item-required {
    color: #ffffff !important;
  }

  .ant-modal-close {
    color: white !important;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
  }
`;
export const StyledModal = styled(Modal)`
  width: 55% !important;

  .ant-modal-content {
    border-radius: 20px;
    background: #1a3652;
  }

  .ant-modal-header {
    background: #1a3652;
  }
  .ant-modal-title {
    color: #ffffff !important;
  }
  .ant-form-item-required {
    color: #ffffff !important;
  }

  .ant-modal-close {
    color: white !important;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
  }
`;
export const StyledDrawer = styled(Drawer)`
  // width: 55% !important;

  .ant-drawer-content {
    background: #f5f5f5 !important;
  }

  .ant-drawer-header {
    background: #fff !important;
  }
  .ant-drawer-title {
    color: #000 !important;
  }
  .ant-form-item-required {
    color: black !important;
  }
  .ant-drawer-close-x {
    color: #000 !important;
  }
  .ant-drawer-footer {
    background: #fff !important;
  }
`;
export const StyledBox = styled.div`
  margin-top: 15px;
  height: 100%;
  width: 100%;
  border: 2px solid grey;
`;
export const StyledBoxLabel = styled.div`
  color: #000
  margin-top: -14px;
  position: absolute;
  left: 60px;
  height: 4%;
  width: 180px;
  text-align: center;
  background-color: #f5f5f5;
  
  font-weight: bold;
`;
export const ActionSelectionDiv = styled.div`
  margin-bottom: 1%;
  margin-top: 1%;
  border: 2px dotted gray;
  display: inline-block;
  padding: 10px;
`;

export const BlockedLabelBlack = styled.label`
  display: block;
  color: #0d0c0c !important;
  font-weight: 700;
  margin-bottom: 7px;
`;
export const ActionCheckbox = styled(CheckboxGroup)`
  font-weight: 300;
`;
export const OnchangeCheckbox = styled(Checkbox)`
  padding-top: 30px !important;
  margin-left: 50px;
  color: #0d0c0c !important;
  font-weight: 700;
`;
export const DatePickerSlider = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row-reverse;
  margin-bottom: 20px;
  margin-right: 20px;
  color: rgba(0, 0, 0, 0.85) !important;
`;
